import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { CostPriceLayout, KitLayout, ReOrderLayout } from '../Layout';
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    FilterPanel,
    Paging,
    Editing,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    Selection,
    Toolbar,
    Item,
    RequiredRule,
    StateStoring
} from "devextreme-react/data-grid";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import "jspdf-autotable";
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import { GridLayout } from "../../../../common/GridLayout";
import { IM } from "../../../../const/constants";
import { set } from "lodash";
import axios from "axios";
import { MESSAGES } from "../../../../common/Messages";
import { PriceLevelColumns } from "../../../../const/Lookup";

function CostPriceTab(props) {
    const dataGrid = useRef(null);
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const gridKey = "746D1DB0-29CC-402A-941D-EC064B76E283";
    const [dataSource, setDataSource] = useState([]);
    const [selectedColoumns, setColoumns] = useState(null);

    // Expose grid ref to parent component
    useEffect(() => {
        if (props.onGridReady) {
            props.onGridReady.current = dataGrid;
        }
    }, [props.onGridReady]);

    // Resize grid when tab becomes visible
    useEffect(() => {
        if (props.isTabVisible && dataGrid.current && dataGrid.current.instance) {
            // Use setTimeout to ensure the tab content is fully rendered
            setTimeout(() => {
                if (dataGrid.current && dataGrid.current.instance) {
                    dataGrid.current.instance().updateDimensions();
                }
            }, 150);
        }
    }, [props.isTabVisible]);

    useEffect(() => {
        const loadData = async () => {
            await fetchSummaryTotalsData();
        };
        loadData();
    }, [props.loadPriceDataGrid]);
    const fetchSummaryTotalsData = async () => {
        try {
            const res = await axios.get(
                `${window._env_.REACT_APP_APIS}/im/PriceCodes/GetPriceCodes`,
                {
                    params: {
                        ItemRowId: props.formFields.RowId,
                        ProfileRowId: props.formFields.ProfileRowId,
                        RPriceTable: props.formFields.RPriceTable,
                        PriceMethod: props.formFields.PriceMethod,
                        CalcMethod: props.formFields.CalcMethod,
                        AverageCost: props.formFields.AverageCost,
                        StandardCost: props.formFields.StandardCost,
                        RoundingMethod: props.formFields.RoundingMethod,
                        RoundingFactor: props.formFields.RoundingFactor,
                        LastCost: props.formFields.LastCost,
                        PriceBasis: props.formFields.PriceBasis,
                        PriceSource: props.formFields.PriceSource,
                        PriceLevelA: props.formFields.PriceLevelA,
                        PriceLevelB: props.formFields.PriceLevelB,
                        PriceLevelC: props.formFields.PriceLevelC,
                        PriceLevelD: props.formFields.PriceLevelD,
                        PriceLevelE: props.formFields.PriceLevelE,
                    }
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );
            if (res.data) {
                let priceLevels = res.data[0]?.NumberOfPriceLevels;
                let cols = [];
                if (priceLevels !== null) {

                    for (let i = 0; i < PriceLevelColumns.length; i++) {
                        const col = PriceLevelColumns[i];
                        cols.push(col);
                        if (col.key === priceLevels) {
                            break;
                        }
                    }
                }
                setColoumns(cols);
                setDataSource(res.data);
                // Resize grid after data is loaded
                setTimeout(() => {
                    if (dataGrid.current && dataGrid.current.instance) {
                        dataGrid.current.instance().updateDimensions();
                    }
                }, 100);
            } else {
                console.warn(MESSAGES.FETCH_ERROR);
            }
        } catch (err) {
            console.log(err, MESSAGES.FETCH_ERROR);
        }
    };
    const currencyFormat = { type: 'currency', precision: 4, useGrouping: true };
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    var accessToken = props.oidc.user.access_token;

    const onContentReady = (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            var selection = e.component.getSelectedRowKeys();
            if (selection.length == 0) {
                e.component.selectRowsByIndexes([0]);
            }
        }
    };
    const handleCellValueChanged = (data) => {
        setSelectedItemKeys(data.selectedRowKeys);
    }
    const handleSelectionChange = useCallback((name, value, e) => {
    }, []);
    return (
        <div className="cost-price-tab-container">
            <style>{`
                .cost-price-tab-container .sortable-lists {
                    height: 46vh !important;
                }
            `}</style>
            <FormField
                currrentUser={currentUser}
                layoutId='766F27B9-4D0A-43F8-B0F1-757EBDCDB272'
                layoutName='IMItemDataEntryCostPriceForm'
                defaultFormSchema={CostPriceLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={props.costPriceFormLoad}
                handleSelectedItemChange={handleSelectionChange}
            />
            <div className="col-md-12">
                <DataGrid

                    onExporting={(e) => {
                        if (window.handleDevExtremeDataGridExport) {
                            window.handleDevExtremeDataGridExport(e);
                        }
                    }}
                    id="gridContainer"
                    onContentReady={onContentReady}
                    dataSource={dataSource}
                    ref={dataGrid}
                    selectedRowKeys={selectedItemKeys}
                    showBorders={true}
                    rowAlternationEnabled={true}
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    columnAutoWidth={true}
                    onSelectionChanged={handleCellValueChanged}
                    height='61vh'
                >
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <StateStoring
                        enabled={true}
                        type="custom"
                        customLoad={loadState}
                        storageKey={gridKey}
                        customSave={saveState}
                    />
                    <Scrolling mode="standard" />
                    <Selection mode="single" />
                    <Export enabled={true} allowExportSelectedData={true} />

                    <Paging enabled={true} defaultPageSize={10} />
                    <Pager
                        visible={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={allowedPageSizes}
                        showNavigationButtons={true}
                        showInfo={true}
                    />
                    <FilterRow visible={true} />
                    <FilterPanel visible={true} />
                    {props.formFields.RPriceTable != null && (
                        <Column dataType="string" dataField="FromQuantity" caption="From Quantity" format={{ type: 'fixedPoint', precision: 4, useGrouping: true }} />
                    )}
                    {selectedColoumns && selectedColoumns.map(col => (
                        <Column
                            key={col.dataField}
                            dataType={col.dataType}
                            dataField={col.dataField}
                            caption={col.caption}
                            format={currencyFormat}
                        />
                    ))}
                    <Toolbar>
                        <Item location="after">
                            <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                        </Item>
                        <Item name="exportButton" />
                        <Item name="columnChooserButton" />
                    </Toolbar>
                </DataGrid>
            </div>
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(CostPriceTab);
